// React DatePicker needs forwardRef to work with custom inputs
import React, { forwardRef } from 'react';
import styled from 'styled-components';

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  variant?: 'filled' | 'outlined' | 'none';
  width?: number;
  height?: number;
}

const StyledInput = styled.input<IProps>`
  ${({ variant, width, height }) => {
    // ... logic remains same, just wrapping it
    switch (variant) {
      case 'filled':
        return `
          padding: 0 0 0 20px;
          width: 100%;
          height: ${height ? height : '38'}px;
          line-height: 38px;
          background: #fff;
          border: 1px solid #ddd;
        `;
      case 'outlined':
        return `
          width: ${width ? width : '200'}px;
          height: ${height ? height : '35'}px;
          padding: 2px 14px;
          font-size: 14px;
          font-weight: 500;
          line-height: 31px;
          border-radius: 4px;
          border: 1px solid #ddd;
          background: #fff;
          &::placeholder {
            color: #aaa;
          }
        `;
      case 'none':
        return `
          display: none;
        `;
      default:
        return `
          width: 100%;
          padding-bottom: 5px;
          border: none;
          background: none;
          border-bottom: 1px solid #ddd;
        `;
    }
  }}
`;

const TextField = forwardRef<HTMLInputElement, IProps>((props, ref) => {
  return <StyledInput {...props} ref={ref} />;
});

export default TextField;
